module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relative bg-white min-h-screen overflow-hidden font-sans",
    attrs: {
      "id": "login"
    }
  }, [_c('div', {
    staticClass: "fixed inset-x-0 bottom-0 z-0 h-56 md:h-72 pointer-events-none"
  }, [_c('svg', {
    staticClass: "w-full h-full text-secondary opacity-30",
    attrs: {
      "viewBox": "0 0 1440 480",
      "fill": "currentColor",
      "preserveAspectRatio": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0,140 C400,320 800,100 1440,280 L1440,480 L0,480Z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "relative z-10 flex flex-col items-center min-h-screen pt-10"
  }, [_c('div', {
    staticClass: "w-full max-w-xs md:max-w-md lg:max-w-lg "
  }, [_c('div', {
    staticClass: "h-32 md:56 bg-no-repeat bg-center bg-contain mb-4",
    style: ({
      backgroundImage: ("url(" + (require('../../img/logo-fi360-nomadia.svg')) + ")")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "pb-4 relative z-10"
  }, [_c('form', {
    staticClass: "space-y-4",
    attrs: {
      "id": "loginform"
    },
    on: {
      "submit": _vm.tryLogin
    }
  }, [_c('div', {
    staticClass: "w-full h-14 md:h-16 flex items-center rounded-lg border border-solid border-gray-400 bg-white pl-3 pr-2 focus-within:border-secondary box-border"
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-user-gear bg-gray-400 flex-shrink-0"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "flex-1 h-full bg-transparent px-3\n       text-gray-900 placeholder-gray-400 text-base md:text-xl\n       border-0 outline-none appearance-none box-border",
    attrs: {
      "type": "email",
      "id": "email",
      "name": "login",
      "placeholder": "Adresse Email",
      "autocomplete": "on"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "w-full h-14 md:h-16 mt-3 flex items-center rounded-lg border border-solid border-gray-400 bg-white pl-3 pr-2 focus-within:border-secondary box-border"
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-lock bg-gray-400 flex-shrink-0"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "flex-1 h-full bg-transparent px-3\n       text-gray-900 placeholder-gray-400 text-base md:text-xl\n       border-0 outline-none appearance-none box-border",
    attrs: {
      "type": "password",
      "id": "password",
      "name": "pwd",
      "placeholder": "Mot de passe",
      "autocomplete": "on"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-4 flex space-x-2"
  }, [_c('input', {
    staticClass: "w-full h-14 md:h-16 text-center bg-primary text-white font-semibold rounded-lg hover:bg-primary-hover transition-colors text-base md:text-xl flex items-center justify-center no-underline appearance-none border-none outline-none shadow-none",
    attrs: {
      "type": "submit",
      "name": "submit",
      "value": "Connexion"
    }
  }), _vm._v(" "), (_vm.isMobile()) ? _c('button', {
    staticClass: "w-full h-14 md:h-16 text-center bg-primary text-white font-semibold rounded-lg hover:bg-primary-hover transition-colors text-base md:text-xl flex items-center justify-center no-underline appearance-none border-none outline-none shadow-none",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.launchAuth()
      }
    }
  }, [_c('i', {
    staticClass: "inline-block h-5 w-5 mask mask-biometric mr-2 bg-white"
  }), _vm._v("\n                            Biométrie\n                        ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "space-y-2"
  }, [_c('a', {
    staticClass: "w-full h-14 md:h-16 text-center bg-primary text-white font-semibold rounded-lg hover:bg-primary-hover transition-colors text-base md:text-xl flex items-center justify-center no-underline shadow-sm",
    attrs: {
      "href": "https://admin.fi360.fr/resetting/request",
      "id": "forget-pwd"
    }
  }, [_vm._v("\n                    Mot de passe oublié\n                ")]), _vm._v(" "), _c('a', {
    staticClass: "w-full h-14 md:h-16 text-center bg-primary text-white font-semibold rounded-lg hover:bg-primary-hover transition-colors text-base md:text-xl flex items-center justify-center no-underline shadow-sm",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateFront($event)
      }
    }
  }, [_vm._v("\n                    Mettre à jour\n                ")]), _vm._v(" "), _c('a', {
    staticClass: "w-full h-14 md:h-16 text-center bg-primary text-white font-semibold rounded-lg hover:bg-primary-hover transition-colors text-base md:text-xl flex items-center justify-center no-underline shadow-sm",
    attrs: {
      "href": _vm.urlSSO
    }
  }, [_vm._v("\n                    Connexion réservée SSO\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "relative z-10 mt-4 flex justify-center",
    staticStyle: {
      "padding-bottom": "env(safe-area-inset-bottom)"
    }
  }, [_c('a', {
    staticClass: "inline-flex items-center justify-center py-6 text-alert font-bold text-sm md:text-lg uppercase no-underline",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clearCache($event)
      }
    }
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-trash bg-alert mr-2"
  }), _vm._v(" "), _c('span', [_vm._v("VIDER MES DONNÉES LOCALES")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bdd5bd8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/Login.vue
// module id = 1030
// module chunks = 0